import { useEffect, useRef, useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '../lib/auth'

/** Benutzermenü in der Kopfzeile: eigenes Konto und Abmelden. */
export function UserMenu() {
  const { me, logout } = useAuth()
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    function onClickOutside(e: MouseEvent) {
      if (!containerRef.current?.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => document.removeEventListener('mousedown', onClickOutside)
  }, [])

  if (!me) return null

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <button
        type="button"
        aria-label={`Benutzermenü für ${me.name}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        style={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          border: '1px solid var(--line)',
          background: 'var(--surf2)',
          color: 'var(--text)',
          font: 'inherit',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        {initials(me.name || me.email)}
      </button>

      {open ? (
        <div
          role="menu"
          className="card"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            width: 260,
            zIndex: 40,
            boxShadow: '0 12px 32px var(--scrim)',
          }}
        >
          <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--line)' }}>
            <div style={{ fontWeight: 600 }}>{me.name}</div>
            <div className="muted" style={{ fontSize: 12 }}>
              {me.email}
            </div>
            {!me.mfa_enabled ? (
              <div style={{ color: 'var(--warn)', fontSize: 12, marginTop: 6 }}>
                Zwei-Faktor-Anmeldung ist nicht eingerichtet.
              </div>
            ) : null}
          </div>
          <button
            type="button"
            role="menuitem"
            className="nav-link"
            style={{ width: '100%', border: 'none', background: 'transparent', cursor: 'pointer' }}
            onClick={() => {
              setOpen(false)
              navigate({ to: '/konto' })
            }}
          >
            Eigenes Konto
          </button>
          <button
            type="button"
            role="menuitem"
            className="nav-link"
            style={{ width: '100%', border: 'none', background: 'transparent', cursor: 'pointer' }}
            onClick={() => {
              setOpen(false)
              logout()
            }}
          >
            Abmelden
          </button>
        </div>
      ) : null}
    </div>
  )
}

function initials(value: string): string {
  const parts = value.split(/[\s@.]+/).filter(Boolean)
  const letters = parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '')
  return letters.join('') || '?'
}
